// project import
import admin from './admin';
import appraisals from './appraisals';
import calendar from './calendar';
import dashboard from './dashboard';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, calendar, appraisals, admin]
};

export default menuItems;
